import { Component, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import {
  InfiniteScrollingService,
  numberComparer,
  equalsCompare
} from '@ipreo/muni-shared';
import { MonitorOverviewViewItem } from '../../../models/monitor';
import {
  performFinalTransformations,
  transformTotals
} from '../../../mappers/monitor-base-page.calculations';
import { NegativeCasesService } from '../../../../gameday/services/negative-cases.service';
import { MonitorOverviewPageService } from '../../../services/monitor-overview-page.service';
import {
  MonitorBasePageComponent,
  monitorBasePageSassVariables
} from '../base-monitor-tab.component';
import { CellClassParams } from 'ag-grid-community';
import { ColumnDefinition } from '../../../../models/column';

// @dynamic
@Component({
  providers: [MonitorOverviewPageService],
  selector: 'muni-gameday-monitor-overview-page',
  templateUrl: './monitor-overview-page.template.html',
  styleUrls: ['../base-monitor-tab.styles.scss'],
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['dataSource'],
  // eslint-disable-next-line @angular-eslint/no-outputs-metadata-property
  outputs: ['maturityClick']
})
export class MonitorOverviewPageComponent
  extends MonitorBasePageComponent<MonitorOverviewPageService>
  implements OnDestroy {
  static readonly columnDefinition: ColumnDefinition[] = [
    {
      field: 'total',
      headerName: 'Total',
      label: 'Total',
      comparator: numberComparer,
      position: 999,
      suppressMenu: true,
      type: 'numericColumn'
    },
    {
      field: 'balance',
      headerName: 'Balance',
      label: 'Balance',
      comparator: numberComparer,
      position: 1001,
      width: 110,
      minWidth: 110,
      maxWidth: 110,
      cellStyle: ({ value }: CellClassParams) => {
        return value > 0
          ? { color: monitorBasePageSassVariables.colorRedDarker }
          : null;
      },
      suppressMenu: true,
      type: 'numericColumn'
    },
    {
      field: 'subscription',
      headerName: 'Subscription',
      label: 'Subscription',
      comparator: numberComparer,
      position: 1002,
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      cellStyle: ({ value }: CellClassParams) => {
        return value < 1
          ? { color: monitorBasePageSassVariables.colorRedDarker }
          : null;
      },
      suppressMenu: true,
      type: 'numericColumn'
    },
    ...MonitorBasePageComponent.columnDefinition
  ];

  static notCategories: string[] = MonitorOverviewPageComponent.columnDefinition.map(
    (item) => item.field
  );

  public readonly categories = this.monitorPageService.getCategories();

  public data: Observable<
    MonitorOverviewViewItem[]
  > = this.monitorPageService
    .getDataCombinedByMaturities()
    .pipe(
      map((data) =>
        data.map((item) =>
          performFinalTransformations(
            item,
            MonitorOverviewPageComponent.notCategories
          )
        )
      )
    );

  public totals: Observable<MonitorOverviewViewItem> = this.monitorPageService
    .calculateTotals()
    .pipe(
      map((totals) =>
        transformTotals(totals, MonitorOverviewPageComponent.notCategories)
      )
    );

  public columnDefinitions: Observable<
    ColumnDefinition[]
  > = this.monitorPageService
    .getColumnDefinitions(
      MonitorOverviewPageComponent.columnDefinition,
      this.categories
    )
    .pipe(distinctUntilChanged(equalsCompare)); // checked, makes sense

  constructor(
    monitorPageService: MonitorOverviewPageService,
    negativeCasesService: NegativeCasesService,
    infiniteScrollingService: InfiniteScrollingService
  ) {
    super(monitorPageService, negativeCasesService, infiniteScrollingService);
  }

  public ngOnDestroy(): void {
    super.onDestroy();
  }
}
